module.exports = __webpack_public_path__ + "img/25_9.39893aa8.png";